import { render, staticRenderFns } from "./TesteWebPKI.vue?vue&type=template&id=1a422963&scoped=true"
import script from "./TesteWebPKI.vue?vue&type=script&lang=js"
export * from "./TesteWebPKI.vue?vue&type=script&lang=js"
import style0 from "./TesteWebPKI.vue?vue&type=style&index=0&id=1a422963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a422963",
  null
  
)

export default component.exports